import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { OnboardingBanner } from '../Banner';

interface Props {
    children: React.ReactNode;
    stepCentered?: boolean;
}

export const OnboardingStepWrapper = ({ children, stepCentered = false }: Props) => (
    <Stack width="100%" gap={{ default: '12', xl: '24' }} height="100%" maxHeight="100%" overflowY="auto">
        <Stack
            direction="column"
            justifyContent={stepCentered ? 'center' : undefined}
            alignItems={stepCentered ? 'center' : undefined}
            flexGrow="1"
            maxHeight="100%"
            paddingTop={stepCentered ? undefined : '6'}
            paddingBottom={{ default: '0', lg: '12' }}
        >
            {children}
        </Stack>

        <Container flexShrink={0} display={{ default: 'none', lg: 'block' }} maxWidth="50%" overflow="hidden">
            <OnboardingBanner />
        </Container>
    </Stack>
);
